export default {
  title: '{{company}} har opdateret dit afhentningstidspunkt',
  title_on_site: '{{company}} har opdateret, hvornår din ordre serveres',
  new_time_label: 'Nyt tidspunkt',
};
